// @flow
import styled, { keyframes } from 'styled-components';
import {
  mr, mb, p, ml, mx, mt
} from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';

import theme from '@theme';
import { colors } from '@components/ListItemFacility/styles';

export const { borderRadius, shadows } = theme;

export const StyledFlowButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  ${breakpoint('mobile', 'tablet')`
    justify-content: space-evenly;
    
    ${({ seemore }) => {
    let cssString = '';
    let displayQuery = '';
    if (seemore) {
      displayQuery = `
      opacity: 1;
      transition: all 0.4s ease-out;
      `;
    } else {
      displayQuery = `
      opacity: 0;
      overflow: hidden;
      transition: all 0.4s ease-out;
      height: 0;
      margin-bottom: 0px;
      button{
        display: none;
      }
      div{
        display: none;
      }
      `;
    }
    for (let i = 9; i < 19; i += 1) {
      cssString += `div{&:nth-child(${i}){${displayQuery}}}\n`;
    }
    return cssString;
  }}
  `}
`;

export const StyledNotesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 90%;
  ${mx(3)}
  ${breakpoint('desktop')`
    flex-direction: row;
    flex-wrap: wrap;
    padding: 30px;
    width: 100%;
    ${mx(1)}
  `}
  ${breakpoint('tablet')`
    width: 95%;
  `}
`;

export const StyledFlowButtonContainer = styled.div`
  ${mb(2.5)}
  ${p(3)}
  ${ml(2)}
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: start;
  ${props => props.seemore && 'justify-content: center;'}
  align-items: center;
  height: 104px;
  width: 31%;
  
  ${breakpoint('mobile', 'tablet')`
    width: 150px;
    ${p(0)}
    ${ml(0)}
    ${mb(4)}
    ${props => props.seemore && mb(0)}}
    height: ${props => (props.seemore ? '60' : '120px')};
  `}
  ${breakpoint('tablet')`
    ${mx(2.5)}
    ${mb(3)}
    height: auto;
    width: 170px;
    flex-direction: column;
    ${props => props.seemore && 'display: none;'}
  `}
  
`;

const shake = keyframes`
  10% {
    transform: translate3d(0px, 0, 0);
  }
  100% {
    transform: translate3d(4px, 0, 0);
  }
`;

export const StyledFlowButton = styled.button`
  border-radius: 50%;
  ${shadows.mediumStrong}
  align-items: center;
  background: none;
  border: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  outline: none;
  background-color: ${theme.colors.white};
  ${breakpoint('tablet')`
    ${mr(0)}
    ${mb(0)}
    ${shadows.default}
    height: 140px;
    width: 140px;
  `}
  ${breakpoint('mobile', 'tablet')`
    ${mr(0)}
    ${mb(0)}
    ${shadows.default}
    height: 100px;
    width: 100px;
  `}
   &:hover{
    animation: ${shake} 0.82s cubic-bezier(.36,.07,.19,.97) both;
    transform: translate3d(0, 0, 0);
    perspective: 1000px;
    box-shadow: 
          0 3px 8px rgba(0 0 0/ 0.2), /* Top shadow */
          0 -3px 8px rgba(0 0 0/ 0.2), /* Bottom shadow */
          3px 0 8px rgba(0 0 0/ 0.2), /* Right shadow */
          -3px 0 8px rgba(0 0 0/ 0.2); 
  }
 
`;

export const StyledIconWrapper = styled.div`
  flex: 0 0 auto;
  height: 80px;
  width: 80px;
  ${p(2)}
  ${mb(3)}
  >svg {
    > path {
      background-color: black !important;
    }
  }
  ${breakpoint('desktop')`
    width: 90px;
    height: 90px;
  `}
`;

export const StyledLabel = styled.div`
  width: 120%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 20px;
  line-height: 1.57;
  text-decoration: none;
  color: ${colors.white};
  font-weight: 600;
  ${breakpoint('mobile', 'tablet')`
    font-size: 16px;
    font-weight: 600;
    line-height: 19px;
    margin-top: 15px;
    ${props =>
    props.seemore
      && `
     border: 2px solid white;
     margin-top: 0px;
     width: 100px;
     padding: 5px;
     border-radius: 8px;
     cursor: pointer;
    `}
  `}
  ${breakpoint('tablet')`
    flex: 0 0 auto;
    ${mt(3)}
  `}
`;
